class ZestMultishipButton extends HTMLElement {
  constructor() {
    super()

    this.handleClick = this.handleClick.bind(this)
    this.button = null
    this.busy = false
  }

  connectedCallback() {
    this.style.display = 'contents'
    this.bindButton()

    if (!this.button) {
      queueMicrotask(() => {
        if (this.isConnected) this.bindButton()
      })
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick)
    this.button = null
    this.busy = false
  }

  bindButton() {
    if (this.button) return

    this.button = this.querySelector('button')
    if (!this.button) return

    this.button.addEventListener('click', this.handleClick)
    this.updateButtonStatus()
  }

  setButtonState(disabled, title = '') {
    if (!this.button) return

    this.button.disabled = disabled
    this.button.setAttribute('aria-disabled', disabled ? 'true' : 'false')
    this.button.title = title
  }

  async updateButtonStatus() {
    try {
      const response = await fetch('/cart.js')
      const cart = await response.json()

      const hasGiftCards = cart.items.some((item) => {
        return item.gift_card || /\b(?:gift[ _-]?card)\b/gi.test(item.product_type)
      })

      const hasSubscriptions = cart.items.some((item) => {
        return item.selling_plan_allocation
      })

      const errorTarget =
        hasGiftCards && hasSubscriptions
          ? 'gift cards and subscriptions'
          : hasGiftCards
          ? 'gift cards'
          : hasSubscriptions
          ? 'subscriptions'
          : null

      if (errorTarget) {
        this.setButtonState(
          true,
          `We're sorry, ${errorTarget} aren't eligible for this feature.`
        )

        return null
      }

      this.setButtonState(false)

      return cart.token
    } catch (error) {
      console.error('Error fetching cart:', error)

      this.setButtonState(false)

      return null
    }
  }

  async handleClick(event) {
    if (!this.button || this.button.disabled || this.busy) {
      event.preventDefault()
      return
    }

    event.preventDefault()

    this.busy = true
    this.setButtonState(true, 'Checking cart...')

    const eligibleCartToken = await this.updateButtonStatus()

    if (eligibleCartToken) {
      this.setButtonState(true, 'Redirecting...')

      window.location.href = `https://${Shopify.shop}/apps/zest/start-multi-ship/${eligibleCartToken}`
      return
    }

    this.busy = false
  }
}

if (!customElements.get('zest-multiship-button')) {
  customElements.define('zest-multiship-button', ZestMultishipButton)
}
